import AtletaNuevo from "pages/LandingPages/AtletaNuevo/atletaNuevo";

export default function AtletaNuevoPage() {
  return <AtletaNuevo />;
}
